import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createContainer, createHook, createStore, defaults } from 'react-sweet-state';

// jira freezes the global defaults object
if (!Object.isFrozen(defaults)) {
  defaults.devtools = process.env.NODE_ENV === 'development' && !process.env.CI;
}
import { ProductFilters, RequestCategory } from '@atlassian/notification-common/types';
import { loadReadStateFilterFromLocalStorage } from '../../utils/local-storage-util';
import actions from './actions';
var Store = createStore({
  initialState: {
    selectedFilters: {
      categoryFilter: RequestCategory.DIRECT,
      readStateFilter: loadReadStateFilterFromLocalStorage(),
      productFilter: ProductFilters.ANY,
      timeRangeFilter: undefined,
      includeActorFilter: undefined,
      excludeActorFilter: undefined
    },
    categoryFilters: [],
    productFilters: []
  },
  actions: actions,
  name: 'notification-filters'
});
var StoreContainer = createContainer(Store, {
  onInit: function onInit() {
    return function (_ref, _ref2) {
      var setState = _ref.setState,
        getState = _ref.getState;
      var categoryFilters = _ref2.categoryFilters,
        productFilters = _ref2.productFilters;
      // initialise the store with read state from local storage
      // store is re-initalised each time the list is opened
      var state = getState();
      setState(_objectSpread(_objectSpread({}, state), {}, {
        categoryFilters: categoryFilters,
        productFilters: productFilters,
        selectedFilters: _objectSpread(_objectSpread({}, state.selectedFilters), {}, {
          readStateFilter: loadReadStateFilterFromLocalStorage()
        })
      }));
    };
  }
});
var useNotificationStateFilters = createHook(Store, {
  selector: function selector(state) {
    return state.selectedFilters;
  }
});
var useNotificationReadStateFilter = createHook(Store, {
  selector: function selector(state) {
    return state.selectedFilters.readStateFilter;
  }
});
var useNotificationCategoryFilters = createHook(Store, {
  selector: function selector(state) {
    return state.categoryFilters;
  }
});
var useNotificationProductFilters = createHook(Store, {
  selector: function selector(state) {
    return state.productFilters;
  }
});
export { StoreContainer, useNotificationStateFilters, useNotificationReadStateFilter, useNotificationCategoryFilters, useNotificationProductFilters };